

export const passwordValidationMsg = 
  "Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character";

export const passwordMismatchMsg = 
  "Please make sure your passwords match";


export const validatePassword = (password) => {
  const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  return regex.test(password);
};


export const validatePasswordMatch = (password, confirmPassword) => {
  return password === confirmPassword && password.length > 0;
};

export const millisToMinutesAndSeconds = (millis) => {
  let minutes = Math.floor(millis / 60000);
  let seconds = ((millis % 60000) / 1000).toFixed(0);
  return minutes + ':' + (seconds < 10 ? "0" : "") + (seconds === 0 ? "00" : seconds);
};
